import React, { useEffect, useState } from 'react'
import GameCard from '../../components/GameCard/GameCard';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import PremiumGames from '../Games/PremiumGames';
import AdCMP from '../../components/ADS/AdCMP';

function Category() {
  const { name } = useParams();
  const [state, setState] = useState([]);

  const getGameListFunc = async () => {
    const api_res = await axios.get("https://pub.gamezop.com/v3/games?id=11190&lang=en")
    if (name === "all-games") {
      setState(api_res?.data?.games);
    } else {
      const New_Data = api_res?.data?.games?.filter((item) => item?.categories?.en[0]?.toLowerCase().replace(/\s+/g, "-") === name);
      setState(New_Data);
    }
  }
  useEffect(() => {
    getGameListFunc();
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [name]);

  return (
    <>
      <Helmet>
        <title>{`${name.replaceAll("-", " ")} Games 🎮 Play Online on VibeOfGames`}</title>
        <meta name="description" content={`Play the Best ${name.replaceAll("-", " ")} Games for Free on VibeOfGames. No Download or Installation Required! 🎮 Play ${state[0]?.name?.en} and many more right now!`} />
        <meta name="keywords" content={`${name.replaceAll("-", " ")} games, free ${state?.category?.en} games, play ${state[0]?.name?.en} online, VibeOfGames`} />

        <meta property="og:title" content={`${name.replaceAll("-", " ")} Games 🎮 Play on VibeOfGames`} />
        <meta property="og:description" content={`Play the Best ${name.replaceAll("-", " ")} Games for Free on VibeOfGames. No Download or Installation Required! 🎮 Play ${state[0]?.name?.en} and many more right now!`} />
        <meta property="og:url" content={`https://vibeofgames.com/category/${name}`} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={`https://vibeofgames.com/assets/images/category/${name}.jpg`} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${name.replaceAll("-", " ")} Games 🎮 Play on VibeOfGames`} />
        <meta name="twitter:description" content={`Play the Best ${name.replaceAll("-", " ")} Games for Free on VibeOfGames. No Download or Installation Required! 🎮 Play ${state[0]?.name?.en} and many more right now!`} />
        <meta name="twitter:image" content={`https://vibeofgames.com/assets/images/category/${name}.jpg`} />

        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://vibeofgames.com/category/${name}`} />

        <script type="application/ld+json">
          {`
{
    "@context": "http://schema.org",
    "@type": "VideoGame",
    "name": "${name.replaceAll("-", " ")}",
    "category": "${name.replaceAll("-", " ")}",
    "url": "https://vibeofgames.com/category/${name}",
    "image": "https://vibeofgames.com/assets/images/category/${name}.jpg",
    "description": "Play the best ${name.replaceAll("-", " ")} games for free on VibeOfGames!",
    "author": {
        "@type": "Organization",
        "name": "VibeOfGames"
    },
    "publisher": {
        "@type": "Organization",
        "name": "VibeOfGames"
    }
}
`}
        </script>

      </Helmet>


      <div className="p-4  mt-14 sm:ml-56">
        <div className="rounded-lg w-full h-fit text-center items-center">
          <div className='hidden xl:block'>
            <AdCMP adSize='1200x280' dataAdSlot="6784508920" />
          </div>

          <div className='hidden lg:block xl:hidden'>
            <AdCMP adSize='1000x280' dataAdSlot="6784508920" />
          </div>

          <div className='hidden md:block lg:hidden'>
            <AdCMP adSize='744x280' dataAdSlot="6784508920" />
          </div>

          <div className='block md:hidden'>
            <AdCMP adSize={`300x250`} dataAdSlot="6784508920" />
          </div>
        </div>
        <h1 className='text-black dark:text-white font-bold text-base'>{name?.toLocaleUpperCase()?.replaceAll("-", " ")} GAMES</h1>
        <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-10 gap-4 mt-1">
          {state && state?.map((_ele, i) => {
            const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
            return (<>
              <GameCard key={i} id={i} slug={GetSlug} name={_ele?.name?.en} banner={_ele?.assets?.square} link={_ele?.URL} />
            </>
            )
          }

          )}
          {state.length === 0 && <div className="col-span-12 lg:col-span-12 rounded-lg bg-white w-full h-40 flex justify-center items-center my-4">
            <h2 className='text-[28px] font-bold'>
              No Games Found.
            </h2>
          </div>
          }
        </div>

        <div className="rounded-lg w-full h-fit text-center items-center">
          <div className='hidden xl:block'>
            <AdCMP adSize='1200x280' dataAdSlot="4229378215" />
          </div>

          <div className='hidden lg:block xl:hidden'>
            <AdCMP adSize='1000x280' dataAdSlot="4229378215" />
          </div>

          <div className='hidden md:block lg:hidden'>
            <AdCMP adSize='744x280' dataAdSlot="4229378215" />
          </div>

          <div className='block md:hidden'>
            <AdCMP adSize={`300x250`} dataAdSlot="4229378215" />
          </div>
        </div>

        <div>
          <div className='flex justify-between items-center'>
            <h1 className='text-black dark:text-white font-bold text-lg mt-2'>🎯 Premium Games</h1>
            <Link to="/category/all-games"><p className='text-black dark:text-white text-xs'>View All ▶</p></Link>
          </div>
          <PremiumGames flag={96} />
        </div>

        <div className="rounded-lg w-full h-fit text-center items-center">
          <div className='hidden xl:block'>
            <AdCMP adSize='1200x280' dataAdSlot="6200935433" />
          </div>

          <div className='hidden lg:block xl:hidden'>
            <AdCMP adSize='1000x280' dataAdSlot="6200935433" />
          </div>

          <div className='hidden md:block lg:hidden'>
            <AdCMP adSize='744x280' dataAdSlot="6200935433" />
          </div>

          <div className='block md:hidden'>
            <AdCMP adSize={`300x250`} dataAdSlot="6200935433" />
          </div>
        </div>
      </div>
    </>
  )
}

export default Category